import { overrideChargeContants } from '../../_constants';
import { overrideChargeServices } from '../../_services';
// import { history } from '../../_helpers';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const overrideChargeActions = {               
    getWayBillRefOverRide,
    getOverRideCode,
    getOverRideList,

    createOverRide,

    updateOverRideId,
    updateOverRideIdStatus,

    deleteOverRideId,

    resetOverrideCharge,        
}
function resetOverrideCharge() { return { type: overrideChargeContants.RESET } }

function overrideChargeFetching() { return { type: overrideChargeContants.OVVERIDECHARGE_FETCHING } }
function overrideChargeFetched() { return { type: overrideChargeContants.OVVERIDECHARGE_FETCHED } }

function overrideChargeSubmitting() { return { type: overrideChargeContants.OVVERIDECHARGE_SUBMITTING } }
function overrideChargeSubmitted() { return { type: overrideChargeContants.OVVERIDECHARGE_SUBMITTED } }

function createOverRide(payload) {
    return dispatch => {
        dispatch(overrideChargeSubmitting());
        dispatch(userActions.notallowLeavePage());
        overrideChargeServices.createOverRide(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(overrideChargeSubmitted());
                    dispatch(alertActions.success('Successfully Waybill Override Charge.'));
                    window.location.href = `/overrideCharge/draft`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(overrideChargeSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function updateOverRideIdStatus(payload, link) {
    return dispatch => {
        dispatch(overrideChargeSubmitting());
        dispatch(userActions.notallowLeavePage());
        overrideChargeServices.updateOverRideIdStatus(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(overrideChargeSubmitted());
                    dispatch(alertActions.success('Waybill Override Status Successfully'));
                    if (link) {
                        window.location.href = link;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(overrideChargeSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function updateOverRideId(payload, id) {
    return dispatch => {
        dispatch(overrideChargeSubmitting());
        dispatch(userActions.notallowLeavePage());
        overrideChargeServices.updateOverRideId(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(overrideChargeSubmitted());
                    dispatch(alertActions.success('Successfully Updated Waybill Override Charge.'));
                    window.location.href = `/overrideCharge/draft`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(overrideChargeSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function deleteOverRideId(payload, userId, isApprover, status, skip, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        overrideChargeServices.deleteOverRideId(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(getOverRideList(userId, isApprover, status, skip, take));
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Waybill Override Charge Successfully.'));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function getOverRideList(userId, isApprover, status, skip, take, search) {
    return dispatch => {
        dispatch(overrideChargeFetching());
        dispatch(userActions.allowLeavePage());
        overrideChargeServices.getOverRideList(userId, isApprover, status, skip, take, search)
            .then(
                overrideList => {
                    dispatch(overrideChargeFetched());
                    if (overrideList.length > 0) {
                        dispatch(success(overrideList));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning('No more data to Load'));
                    }
                },
                error => {
                    dispatch(overrideChargeFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(overrideList) { return { type: overrideChargeContants.OVERRIDE_LIST, overrideList } }
}

function getOverRideCode(code) {
    return dispatch => {
        dispatch(overrideChargeFetching());
        overrideChargeServices.getOverRideCode(code)
            .then(
                overrideCodeData => {
                    dispatch(overrideChargeFetched());
                    dispatch(success(overrideCodeData));
                },
                error => {
                    dispatch(overrideChargeFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(overrideCodeData) { return { type: overrideChargeContants.GET_OVERRIDE_CODE, overrideCodeData } }
}

function getWayBillRefOverRide(code) {
    return dispatch => {
        dispatch(overrideChargeFetching());
        overrideChargeServices.getWayBillRefOverRide(code)
            .then(
                wbOverride => {
                    dispatch(overrideChargeFetched());
                    dispatch(success(wbOverride));
                },
                error => {
                    dispatch(overrideChargeFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(wbOverride) { return { type: overrideChargeContants.OVERRIDE_GET_WB, wbOverride } }
}